import { WithAuthorization } from "../../context";
import { Page } from "../../components/Page";
import { useTranslation } from "react-i18next";
import { Box, Center, Flex, Icon, Link, Text, useBreakpointValue, useToast } from "@chakra-ui/react";
import { FaGlobe, FaLinkedinIn } from "react-icons/fa";
import * as React from "react";
import { Card } from "../../components/Card";
import { SupplierQuestionnairesSummary, SupplierSpecificReport } from "./components";
import { useGetUserSpecificSupplier } from "../../hooks/query";
import { showErrorToast } from "../../utils";

function SupplierDashboard() {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierDashboard"
  });
  const containerFlow = useBreakpointValue({
    xl: "row",
    base: "column"
  });
  const toast = useToast();

  const {
    data: supplierData
  } = useGetUserSpecificSupplier({
    onError: (err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message)
  })

  return (
    <Page title={t("page.title", { supplierName: supplierData ? supplierData.name : "" })}
          subTitle={t("page.subTitle", { supplierName: supplierData ? supplierData.name : "" })}>
      <Card>
        <Flex flexFlow={containerFlow}>
          <Box width={containerFlow === "row" ? "45%" : "100%"}>
            <SupplierQuestionnairesSummary />
          </Box>
          <Box width={containerFlow === "row" ? "55%" : "100%"}>
            <SupplierSpecificReport containerFlow={containerFlow} />
          </Box>
        </Flex>
        <Center>
          <Text size="md" margin="5" mb="0">
            {t("page.systemSupport") + " "}
            <Link href="mailto: support@esg360.io" isExternal color={"esg_link"} fontWeight="semibold">
              support@esg360.io
            </Link>
          </Text>
        </Center>
        <Center mt={2}>
          <Link href="https://esg360.io" isExternal color={"blue"} mr="2">
            <Icon
              as={FaGlobe}
              inlineSize="5"
              blockSize="5"
              color="esg_link"
              opacity="0.8"
            />
          </Link>
          <Link href="https://linkedin.com/company/esg360°" isExternal color={"blue"}>
            <Icon
              as={FaLinkedinIn}
              inlineSize="5"
              blockSize="5"
            />
          </Link>
        </Center>
      </Card>
    </Page>
  );
}

export default WithAuthorization(SupplierDashboard);